<div class="row" *ngIf="showHeaderText">
  <div class="col-md-12">
    <div class="formheadertext text-center">
      <p innerHTML={{headerText}}></p>
    </div>
  </div>
</div>
